import React, {useMemo} from 'react';
import {classes, style, vars} from './doppe-action-widget-toggle-switch.st.css';
import {
    Checkbox,
    CheckboxCheckedState,
    CheckboxComponent,
    reactCreateMemo,
    reactForwardRef
} from "@wix/devzai-utils-react";
import {colorWhiten, evaluateFunction, OmitStrict, Values} from "@wix/devzai-utils-common";
import {BymoPageStyleScopeVarsNames, useBymoPageStyleScopeVarValue} from "../bymo-page-style/bymo-page-style";

export const DoppeActionWidgetToggleSwitchSize = {
    Small: 'small',
    Medium: 'medium',
} as const;

export type DoppeActionWidgetToggleSwitchSize = Values<typeof DoppeActionWidgetToggleSwitchSize>;

export const DoppeActionWidgetToggleSwitch = reactCreateMemo(reactForwardRef(function DoppeActionWidgetToggleSwitch (props: DoppeActionWidgetToggleSwitch.Props) {
    const {
        children,
        ref,
        disabled = false,
        size = DoppeActionWidgetToggleSwitchSize.Medium,

        style: styleProp,
        className,
        ...checkboxProps
    } = props;

    const mainColor = useBymoPageStyleScopeVarValue(BymoPageStyleScopeVarsNames.bymoPageStyleScopeMainColor);

    const whitenMainColor = useMemo(() => colorWhiten(mainColor, 0.4), [mainColor])

    return (
        <Checkbox<CheckboxCheckedState.Boolean>
            ref={ref}
            className={style(classes.root, className)}
            style={{
                ...evaluateFunction(() => {
                    switch (size) {
                        case DoppeActionWidgetToggleSwitchSize.Medium: {
                            return {
                                [vars.toggleSwitchWidth]: '32px',
                                [vars.toggleSwitchHeight]: '20px',
                                [vars.handleMargin]: '2px',
                            }
                        }
                        case DoppeActionWidgetToggleSwitchSize.Small: {
                            return {
                                [vars.toggleSwitchWidth]: '28px',
                                [vars.toggleSwitchHeight]: '18px',
                                [vars.handleMargin]: '2px',
                            }
                        }
                        default: {
                            return undefined;
                        }
                    }
                }),
                [vars.whitenMainColor]: whitenMainColor ?? undefined,
                ...styleProp
            }}
            disabled={disabled}
            {...checkboxProps}
        >
            {() => {
                return (
                    <>
                        <div
                            className={style(classes.checkboxView, {hasSiblings: !!children})}
                            tabIndex={disabled ? -1 : 0}
                        >
                            <div
                                className={style(classes.handle, {})}
                            />
                        </div>
                        {children}
                    </>
                )
            }}
        </Checkbox>
    );
}));

export namespace DoppeActionWidgetToggleSwitch {

    export interface Props extends OmitStrict<CheckboxComponent.Props<CheckboxCheckedState.Boolean>, 'children'> {
        children?: React.ReactNode;
        size?: DoppeActionWidgetToggleSwitchSize;
    }
}
